import { useState, useMemo, type FC } from "react";
import { Route, Switch } from "react-router-dom";
import {
  HamburgerButton,
  Header as GenericHeader,
  IconComponent,
  IconName,
} from "@hopper-b2b/ui";
import clsx from "clsx";
import ClientLogo from "../../../../assets/client/client-logo.svg?react";
import { B2B_LOGO_ALT, HOPPER_LOGO_ALT } from "../../../../utils/constants";
import {
  PATH_HOME,
  PATH_FLIGHTS,
  PATH_FLIGHTS_BOOK_CONFIRMATION,
  PATH_FLIGHTS_SEARCH,
} from "../../../../utils/urlPaths";
import MobileHamburgerMenu from "../../../MobileHamburgerMenu";
import "./styles.scss";

interface IMobileHeaderProps {
  openSupportChat?: () => void;
}

const HeaderLogos: FC = () => (
  <div className={clsx("header-logo-container")}>
    <ClientLogo
      aria-label={B2B_LOGO_ALT}
      className={clsx("mobile img-logo client-logo header-logo-client")}
    />
    <hr className={clsx("header-logo-divider")} />
    <IconComponent
      ariaLabel={HOPPER_LOGO_ALT}
      className={clsx("mobile img-logo header-logo-hopper")}
      name={IconName.HopperLogo}
    />
  </div>
);

const MobileHeader = ({ openSupportChat }: IMobileHeaderProps) => {
  const [showMenu, setShowMenu] = useState(false);

  const hamburger = useMemo(
    () => (
      <HamburgerButton
        onOpen={() => setShowMenu(true)}
        onClose={() => setShowMenu(false)}
        open={showMenu}
        menu={
          <MobileHamburgerMenu
            onClose={() => setShowMenu(false)}
            openSupportChat={openSupportChat}
          />
        }
      />
    ),
    [openSupportChat, showMenu]
  );

  const renderGenericHeader = (isConfirmation: boolean) => (
    <GenericHeader
      isMobile={true}
      shadow={true}
      className={clsx("b2b", { confirmation: isConfirmation })}
      left={
        <div className={clsx("header-logo")}>
          <a href={PATH_HOME}>
            <HeaderLogos />
          </a>
        </div>
      }
      right={hamburger}
    />
  );

  return (
    <Switch>
      <Route
        path={[PATH_FLIGHTS]}
        render={() => renderGenericHeader(false)}
        exact
      />
      <Route
        path={[PATH_FLIGHTS_BOOK_CONFIRMATION]}
        render={() => renderGenericHeader(true)}
        exact
      />
      <Route path={PATH_FLIGHTS_SEARCH} />
      <Route path="*" render={() => renderGenericHeader(false)} />
    </Switch>
  );
};

export { HeaderLogos, MobileHeader };
